import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const GET_ITEM_QUERY = print(gql`
  query FindOne($id: Int, $slug: String) {
    Form(id: $id, slug: $slug) {
      id
      slug
      sendResponsesTo {
        email
      }
    }
  }
`);

export interface GetItemGql {
  Form: {
    id: number;
    slug: string;
    sendResponsesTo: {
      email: string;
    }[];
  };
}
